/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import axios from "axios";
import { API } from "./Define";

export const FetchData = (mothod, url, token, payload = {}) => {
  return new Promise((resolve, reject) => {
    axios(API + url, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      method: mothod,
      data: payload,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const FetchURL = (mothod, url, token, payload = {}) => {
  return new Promise((resolve, reject) => {
    axios(url, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      method: mothod,
      data: payload,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const PostData = (url, payload = {}) => {
  return new Promise((resolve, reject) => {
    axios(API + url, {
      headers: { "Content-Type": "application/json" },
      method: "post",
      data: payload,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
